import * as t from 'io-ts';
export var MultilingualConfig = t.type({
  hubDefaultLang: t.string
});
var Error = t.type({
  message: t.string
});
export var Language = t.type({
  id: t.string,
  name: t.string,
  code: t.string,
  displayName: t.string
});
export var UpdateLanguageOutput = t.type({
  editProfile: t.union([t.type({
    __typename: t.literal('EditProfileErrors'),
    errors: t.array(Error)
  }), t.type({
    __typename: t.literal('EditProfileResult'),
    result: t.type({
      id: t.string,
      language: Language
    })
  })])
});